import React from "react";
import classes from "./marketing.module.css";
import { MarketingData } from "../../data/marketingData/MarketingData";

const Marketing = () => {
  return (
    <div className={classes.container} id="marketing">
      <div className={classes.subContainer}>
        <h2 className={classes.title}>Recent Posts</h2>
        {/* <h2 className={classes.subTitle}>Explore our recent posts</h2> */}
        <div className={`${classes.scrollableContainer}`}>
          <div className={classes.cardsContainer}>
            {MarketingData.map((item, index) => {
              return (
                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.anchorTag}
                >
                  <div className={`${classes.marketingCard}`}>
                    <div className={classes.marketingImage}>
                      <img
                        src={item.image}
                        alt="marketing"
                        title="Marketing Card"
                        className={classes.marketingImage}
                      />
                    </div>
                    {/* <p className={classes.publishBy}>{item.publishBy}</p> */}
                    <h3 className={classes.publishTitle}>
                      {item.publishTitle}
                    </h3>
                    <h3 className={`${classes.publishDescription}`}>
                      {item.publishDescription}
                    </h3>
                    <div className={`${classes.badgesContainer} gap-2`}>
                      <p
                        className={`${classes.badges} rounded-pill`}
                        style={{
                          background:
                            item.badges === "Skalebot Pro" || "Management"
                              ? "#F8F9FC"
                              : "#F9F5FF",
                          color:
                            item.badges === "Skalebot Pro" || "Management"
                              ? "#363F72"
                              : "#707070"
                        }}
                      >
                        {item.badges[0]}
                      </p>
                      <p
                        className={`${classes.badges} rounded-pill`}
                        style={{
                          background:
                            item.badges === "Skalebot Pro" || "Management"
                              ? "#F8F9FC"
                              : "#F9F5FF",
                          color:
                            item.badges === "Skalebot Pro" || "Management"
                              ? "#363F72"
                              : "#707070"
                        }}
                      >
                        {item.badges[1]}
                      </p>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marketing;
